import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Button from '../../common/CustomComponents/Button.js'
class VendorsAdd extends React.Component {
  state = {
    vendorCode: '',
    isData: false,
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  onSaveData = () => {
    this.dashbord()
  }
  componentDidMount() {
    this.getVendorLists()
  }
  getVendorLists = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/list-vendors', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.Vendors_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  dashbord = async () => {
    var that = this
    var data = {
      id: that.props.Vendors_id,
      vendorCode: that.state.vendorCode,
    }
    this.setState({ isData: true })
    if (this.props.Vendors_id) {
      await axios
        .put(Constant.getAPI() + '/admin/edit-vendor', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.setState({ isData: false })
          Swal.fire({
            title: 'Vendors Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = '#/Vendor'
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }
  render() {
    return (
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Vendor Code</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  name="vendorCode"
                  id="vendorCode"
                  placeholder="vendorCode"
                  onChange={this.handleChange}
                  value={this.state.vendorCode}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 text-right">
            <Button
              disabled={this.state.isData}
              onClick={this.onSaveData}
              startIcon={<i className="icofont icofont-save"></i>}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default VendorsAdd
